import React, { useState } from 'react'
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";
import LazyLoad from "react-lazyload";
const OfficeBearers = () => {
   const[selectedYear,setSelectedYear] = useState('show1');
    return (
        <>
            <Header />
            <Breadcrumb mid="Academics" breadcrumbName="Office Bearers" />
            <div className="innerSection">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="title">
                                <div>
                                    <h1> School Office Bearers</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12">
                    <div className="chooseyear">
                        <select id="chooseddlYear"
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(e.target.value)}
                            className="yearSelection"
                        >
                            <option value="show1">2024 -2025</option> 
                            <option value="show2">2023 -2024</option>  
                        </select>
                    
                    </div>
                </div>
                    <div className="clr"></div>
                   {selectedYear === 'show1' && (
                    <div className="row g-4">
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/1. Parinat Majumdar XII A SCHOOL HEAD BOY.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   Parinat Majumdar </h4>
                        <p>  XII-A SCHOOL HEAD BOY </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/2. Amrita Singh XII A.  SCHOOL HEAD GIRL.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   Amrita Singh  </h4>
                        <p>  XII-A  SCHOOL HEAD GIRL </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/3. Aakarsh Srivastava XI B SCHOOL VICE HEAD BOY.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Aakarsh Srivastava </h4>
                        <p>  XI-B SCHOOL VICE HEAD BOY </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/4. Aparajita Mohan XI B SCHOOL VICE HEAD GIRL.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   Aparajita Mohan </h4>
                        <p> XI-B SCHOOL VICE HEAD GIRL  </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/5. Vikas Kumar XII A SPORTS CAPTAIN.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Vikas Kumar   </h4>
                        <p> XII-A SPORTS CAPTAIN </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/6. Nancy Mishra XII A-SPORTS CAPTAIN (GIRL).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   Nancy Mishra   </h4>
                        <p> XII-A SPORTS CAPTAIN (GIRL) </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/7. Harshit Srivastava XI C-SPORTS VICE CAPTAIN.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   Harshit Srivastava   </h4>
                        <p> XI-C SPORTS VICE CAPTAIN </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/8. Hritvi Singh XI B-SPORTS VICE CAPTAIN (GIRL).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Hritvi Singh  </h4>
                        <p> XI-B SPORTS VICE CAPTAIN (GIRL) </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/9. Shivam Pandey XII B-(BLUE HOUSE CAPTAIN).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Shivam Pandey   </h4>
                        <p> XII B (BLUE HOUSE CAPTAIN) </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/10. D R Jeny XII B BLUE HOUSE CAPTAIN (GIRL).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   D R Jeny  </h4>
                        <p> XII B BLUE HOUSE CAPTAIN (GIRL)  </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/11. Shubh Patel XI B- BLUE HOUSE VICE CAPAIN.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   Shubh Patel   </h4>
                        <p> XI B- BLUE HOUSE VICE CAPAIN </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/12. Anushree XI A BLUE HOUSE VICE CAPTAIN.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   Anushree   </h4>
                        <p> XI A BLUE HOUSE VICE CAPTAIN </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/13. Raj Malviya XII B-GOLD HOUSE CAPTAIN.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Raj Malviya  </h4>
                        <p> XII B-GOLD HOUSE CAPTAIN </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/14. Shivi Yadav XII B-GOLD HOUSE CAPTAIN.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   Shivi Yadav   </h4>
                        <p> XII B-GOLD HOUSE CAPTAIN </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/15. Shani Maurya XI C-GOLD HOUSE VICE CAPTAIN.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   Shani Maurya   </h4>
                        <p> XI C-GOLD HOUSE VICE CAPTAIN </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/16. Sejal Dubey XI C-GOLD HOUSE VICE CAPTAIN.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Sejal Dubey  </h4>
                        <p>  XI C-GOLD HOUSE VICE CAPTAIN</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/17. Naman Sahu XII B-RED HOUSE CAPTAIN.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Naman Sahu </h4>
                        <p>  XII B-RED HOUSE CAPTAIN </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/18. Inaya Khurshid XII A-RED HOUSE CAPTAIN.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Inaya Khurshid  </h4>
                        <p> XII A-RED HOUSE CAPTAIN  </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/19. Ayush Kumar XI A-RED HOUSE VICE CAPTAIN.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Ayush Kumar   </h4>
                        <p> XI A-RED HOUSE VICE CAPTAIN </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/20. Rachel Gupta XI C-RED HOUSE VICE CAPTAIN (GIRL).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Rachel Gupta   </h4>
                        <p> XI C-RED HOUSE VICE CAPTAIN (GIRL) </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/21. Utkarsh Tiwari XII B-GREEN HOUSE CAPTAIN.jpg" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Utkarsh Tiwari  </h4>
                        <p> XII B-GREEN HOUSE CAPTAIN </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/23. Kritika Singh XII B-GREEN HOUSE CAPTAIN (GIRL).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Kritika Singh  </h4>
                        <p> XII B-GREEN HOUSE CAPTAIN (GIRL)  </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/24. Upmanyu Mishra XI B-GREEN HOUSE VICE CAPTAIN.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Upmanyu Mishra   </h4>
                        <p> XI B-GREEN HOUSE VICE CAPTAIN </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/25. Haniya Mohd. Arif-GREEN HOUSE VICE CAPTAIN (GIRL ).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Haniya Mohd. Arif   </h4>
                        <p>GREEN HOUSE VICE CAPTAIN (GIRL ) </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/26. Aastha Jaiswal XII A-PRESIDENT LIT. ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   Aastha Jaiswal  </h4>
                        <p> XII A-PRESIDENT LIT. ASSOCIATION </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/27. BIBi Zainab Salim XI B-VICE PRESIDENT LIT ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   BIBi Zainab Salim   </h4>
                        <p> XI B-VICE PRESIDENT LIT ASSOCIATION </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/28. Shreya XII B-PRESIDENT HINDI ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Shreya   </h4>
                        <p> XII B-PRESIDENT HINDI ASSOCIATION </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/29. Sankalp Pandey XI A-VICE PRESIDENT HINDI ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   Sankalp Pandey  </h4>
                        <p> XI A-VICE PRESIDENT HINDI ASSOCIATION </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/30. Rishika Srivastava XII B-PRESIDENT IT ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Rishika Srivastava </h4>
                        <p> XII B-PRESIDENT IT ASSOCIATION  </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/31. Vasundhara Bind XI A-VICE PRESIDENT IT ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Vasundhara Bind  </h4>
                        <p> XI A-VICE PRESIDENT IT ASSOCIATION  </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/32. Satyam Pandey XII A-PRESIDENT ART ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   Satyam Pandey </h4>
                        <p> XII A-PRESIDENT ART ASSOCIATION  </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/33 . Insha Rizvi XI A-VICE PRESIDENT ART ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   Insha Rizvi  </h4>
                        <p> XI A-VICE PRESIDENT ART ASSOCIATION </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/34. Khushboo Tiwari XII A-PRESIDENT SCIENCE ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   Khushboo Tiwari  </h4>
                        <p> XII A-PRESIDENT SCIENCE ASSOCIATION  </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/35. Akshat Kesharvani XI B-VICE PRESIDENT SCIENCE ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Akshat Kesharvani   </h4>
                        <p> XI B-VICE PRESIDENT SCIENCE ASSOCIATION </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/36. Shatakshi Srivastava XII C-PRESIDENT COMMERCE ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Shatakshi Srivastava   </h4>
                        <p> XII C-PRESIDENT COMMERCE ASSOCIATION </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/37. Prabhjot Kaur XI C-VICE PRESIDENT COMMERCE ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>   Prabhjot Kaur </h4>
                        <p> XI C-VICE PRESIDENT COMMERCE ASSOCIATION   </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/38. Divy Pratap Singh XII B-PRESIDENT MUSIC ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Divy Pratap Singh  </h4>
                        <p> XII B-PRESIDENT MUSIC ASSOCIATION  </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/39. Harshita Mishra XI B-VICE PRESIDENT ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Harshita Mishra  </h4>
                        <p> XI B-VICE PRESIDENT ASSOCIATION</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/40. Ankita Kushwaha XII C-PRESIDENT ENVIRONMENTAL CLUB.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Ankita Kushwaha   </h4>
                        <p> XII C-PRESIDENT ENVIRONMENTAL CLUB </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/41. Jay Jaiswal XI B-VICE PRESIDENT ENVIRONMENTAL CLUB.JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Jay Jaiswal </h4>
                        <p> XI B-VICE PRESIDENT ENVIRONMENTAL CLUB  </p>
                    </div>
                </div>
                    </div>
                   )} 
                   {selectedYear === 'show2' && (
                    <div className="row g-4">
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/1.Akshat Srivastav (School Head Boy).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Akshat Srivastav  </h4>
                        <p> (School Head Boy) </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/2.Arikta Tripathi (School Head Girl).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Arikta Tripathi </h4>
                        <p> (School Head Girl)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/3.Parinat Majumdar (School Vice Head  Boy).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Parinat Majumdar </h4>
                        <p>(School Vice Head  Boy)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/4.Amrita Singh (School Head Girl).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Amrita Singh</h4>
                        <p> (School Head Girl) </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/5.Rahul Singh (Sports Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Rahul Singh (Sports Captain)</h4>
                        <p>(Sports Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/6.Nikhar Sonkar (Sports Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Nikhar Sonkar (Sports Captain) </h4>
                        <p>(Sports Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/7.Satvik Singh (Sports Vice Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Satvik Singh  </h4>
                        <p>(Sports Vice Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/8.Nancy Mishra (Sports Vice Captain).jpg" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Nancy Mishra  </h4>
                        <p>(Sports Vice Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/9. ABHISHEK AGRAWAL (Blue House Captain).jpg" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  ABHISHEK AGRAWAL  </h4>
                        <p>(Blue House Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/10.Drishti Singh (Blue House Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Drishti Singh</h4>
                        <p>  (Blue House Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/11.Shivam Pandey (Blue house Vice Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Shivam Pandey </h4>
                        <p>(Blue house Vice Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/12. D. R. Jeni (Blue house Vice Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  D. R. Jeni </h4>
                        <p>(Blue house Vice Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/13.Sparsh Singh (Gold house  Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Sparsh Singh </h4>
                        <p>(Gold house  Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/14.Sania Pandey (Gold house  Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Sania Pandey </h4>
                        <p>(Gold house  Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/15. Aryan Keshri (Gold house Vice  Captain).jpg" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Aryan Keshri  </h4>
                        <p> (Gold house Vice  Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/16. Shreya (Gold house Vice  Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Shreya </h4>
                        <p>(Gold house Vice  Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/17. Divyansh Singh Yadav (Red house Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Divyansh Singh Yadav  </h4>
                        <p>(Red house Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/18. Anmesha Priyam (Red house Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Anmesha Priyam </h4>
                        <p>(Red house Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/19. Aman Rai (Red house Vice  Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Aman Rai  </h4>
                        <p>(Red house Vice  Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/20. Inaya Khurshid (Red house Vice  Captain).jpg" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Inaya Khurshid </h4>
                        <p>(Red house Vice  Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/21. Krishna Pandey (Green house   Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Krishna Pandey  </h4>
                        <p>(Green house   Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/22. Kathyani Chaurasia (Green house   Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Kathyani Chaurasia  </h4>
                        <p>(Green house   Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/23. Omkareshwar Jaiswal  (Green house  Vice Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Omkareshwar Jaiswal </h4>
                        <p> (Green house  Vice Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/24. Kritika Singh (Green house Vice  Captain).jpg" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Kritika Singh </h4>
                        <p>(Green house Vice  Captain) </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/25. Yash Vardhan Singh (President Lit. Association).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Yash Vardhan Singh  </h4>
                        <p>(President Lit. Association)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/26. Yashvi Misra (President Hindi Association).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Yashvi Misra  </h4>
                        <p>(President Hindi Association)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/27. Rijul Maurya (President IT Association).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Rijul Maurya </h4>
                        <p>(President IT Association) </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/28. Amit Yadav (President Art Association).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Amit Yadav </h4>
                        <p>(President Art Association)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/29. Ashish Ranjan (President Science Association).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Ashish Ranjan </h4>
                        <p>(President Science Association)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/30. Ananya Singh ( President Commerce Association).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Ananya Singh </h4>
                        <p>( President Commerce Association)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/31. Bhoomi Srivastava (President Music Association).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Bhoomi Srivastava  </h4>
                        <p>(President Music Association)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/32. Deepali Dubey (President Environmental Club).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Deepali Dubey </h4>
                        <p>(President Environmental Club) </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/33. Vishisht Pandey (Jr. School Head Boy).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Vishisht Pandey  </h4>
                        <p>(Jr. School Head Boy)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/34. Chaitanya( Jr. Head Girl).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Chaitanya</h4>
                        <p>( Jr. Head Girl)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/35. Lakshya Kataria( Jr. Vice Head Boy).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Lakshya Kataria  </h4>
                        <p>( Jr. Vice Head Boy)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/36. Alvia Abidi (Jr. Vice Head Girl).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Alvia Abidi </h4>
                        <p> (Jr. Vice Head Girl) </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/37. Parth Singh (jr. Sports Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Parth Singh  </h4>
                        <p>(jr. Sports Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/38. Riddhi Singh Gautam (Jr. Sports Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Riddhi Singh Gautam  </h4>
                        <p>(Jr. Sports Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/39. Tejas Srivastav(Jr. Sports Vice Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Tejas Srivastav </h4>
                        <p>(Jr. Sports Vice Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/40. Sakshi Bind (Jr. Sports Vice Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Sakshi Bind  </h4>
                        <p>(Jr. Sports Vice Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/41. Divyansh Mehrotra( Jr. Blue house Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Divyansh Mehrotra </h4>
                        <p>( Jr. Blue house Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/42. Saumya( Jr. Blue house Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Saumya </h4>
                        <p>( Jr. Blue house Captain) </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/43. Ishkirat Singh  Jr. Blue house Vice Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Ishkirat Singh   </h4>
                        <p>Jr. Blue house Vice Captain </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/44. Aavya Yadav  Jr. Blue house Vice Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Aavya Yadav   </h4>
                        <p>Jr. Blue house Vice Captain</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/45. Sarthak Singh  Jr. Gold house Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Sarthak Singh  </h4>
                        <p> Jr. Gold house Captain </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/46. Sanvi Singh Jr. Gold house Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Sanvi Singh </h4>
                        <p> Jr. Gold house Captain </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/47. Himesh Raj Singh Jr. Gold house Vice Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Himesh Raj Singh </h4>
                        <p>Jr. Gold house Vice Captain</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/48. Vedika Srivastav  Jr. Gold house Vice Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Vedika Srivastav   </h4>
                        <p> Jr. Gold house Vice Captain </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/49. Dev Narayan CD  (Jr. Red house Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Dev Narayan CD   </h4>
                        <p>(Jr. Red house Captain)</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/50. Ketaki Singh  Jr. Red house Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Ketaki Singh  </h4>
                        <p>Jr. Red house Captain</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/51. Aarav Kashyap  Jr. Red house Vice Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Aarav Kashyap  </h4>
                        <p>Jr. Red house Vice Captain </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/52. Pratyusha Tripathi  Jr. Red house Vice Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Pratyusha Tripathi   </h4>
                        <p>Jr. Red house Vice Captain</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/53. Arpit Verma  Jr. Green house Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Arpit Verma   </h4>
                        <p>Jr. Green house Captain </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/54. Ananya Yadav  Jr. Green house Captain).jpg" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Ananya Yadav   </h4>
                        <p>Jr. Green house Captain </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/55. Pratyush Sahani Jr. Green house Vice Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4>  Pratyush Sahani </h4>
                        <p>Jr. Green house Vice Captain </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="common-box">
                        <LazyLoad>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/56. Tanushka Srivastav  Jr. Green house Vice Captain).JPG" alt="St mary school, mirzapur" />
                        </LazyLoad>
                        <h4> Tanushka Srivastav </h4>
                        <p> Jr. Green house Vice Captain </p>
                    </div>
                </div>
                    </div>
                   )}
                   {  /*   <div className="row g-4">
                        <div className='col-12'>
                            <h3 className='heading'><b>Class I</b></h3>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-A-HEADBOY.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4> Parinat Majumdar  </h4>
                                <p> XII A-HEAD BOY </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-A-HEADGIRL.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>  Amrita Singh </h4>
                                <p> XII A-HEAD GIRL </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XI-B-VICE-HEADBOY.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4> Aakarsh Srivastava  </h4>
                                <p> XI B-VICE HEAD BOY</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XI-B-VICE-HEADGIRL.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Aparajita Mohan</h4>
                                <p> XI B-VICE HEAD GIRL</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-A-SPORTSCAPTAIN.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Vikas Kumar </h4>
                                <p>XII A SPORTS CAPTAIN</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-A-SPORTSCAPTAIN.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Vikas Kumar </h4>
                                <p>XII A SPORTS CAPTAIN</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-A-SPORTSCAPTAIN-girl.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4> Nancy Mishra </h4>
                                <p>XII A SPORTS CAPTAIN (GIRL)</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XI-C-SPORTS-VICECAPTAIN.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4> Harshit Srivastava </h4>
                                <p>XI C-SPORTS VICE CAPTAIN</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XI-B-SPORTS-VICECAPTAIN.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4> Hritvi Singh </h4>
                                <p>XI B-SPORTS VICE CAPTAIN (GIRL)</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-B-BLUE-HOUSECAPTAIN.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Shivam Pandey </h4>
                                <p>XII B-(BLUE HOUSE CAPTAIN) </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-B-BLUE-HOUSECAPTAIN-GIRL.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>D R Jeny XII B BLUE HOUSE CAPTAIN (GIRL)</h4>
                                <p>XII B-(BLUE HOUSE CAPTAIN) </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XIB-BLUE-HOUSE-VICECAPAIN.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Shubh Patel </h4>
                                <p>XI B- BLUE HOUSE VICE CAPAIN</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XIA-BLUE-HOUSE-VICE-CAPTAIN.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4> Anushree </h4>
                                <p>XI A BLUE HOUSE VICE CAPTAIN</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XIIB-GOLD-HOUSE-CAPTAIN.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4> Raj Malviya </h4>
                                <p> XII B-GOLD HOUSE CAPTAIN</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XIIB-GOLD-HOUSE-CAPTAIN-1.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Shivi Yadav </h4>
                                <p> XII B-GOLD HOUSE CAPTAIN</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XI-C-GOLD-HOUSE-VICE-CAPTAIN.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Shani Maurya </h4>
                                <p>XI C-GOLD HOUSE VICE CAPTAIN</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XI-C-GOLD-HOUSE-VICE-CAPTAIN-1.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Sejal Dubey </h4>
                                <p>XI C-GOLD HOUSE VICE CAPTAIN</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-B-RED-HOUSE-CAPTAIN.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Naman Sahu</h4>
                                <p>XII B-RED HOUSE CAPTAIN </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-A-RED-HOUSE-CAPTAIN.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Inaya Khurshid </h4>
                                <p>XII A-RED HOUSE CAPTAIN </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-A-RED-HOUSE-VICECAPTAIN.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Ayush Kumar </h4>
                                <p>XI A-RED HOUSE VICE CAPTAIN </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XI-C-RED-HOUSE-VICE-CAPTAIN-GIRL.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Rachel Gupta </h4>
                                <p>XI C-RED HOUSE VICE CAPTAIN (GIRL)</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-B-GREEN-HOUSE-CAPTAIN.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Utkarsh Tiwari </h4>
                                <p>XII B-GREEN HOUSE CAPTAIN</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XIIB-GREEN-HOUSECAPTAIN-GIRL.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Kritika Singh </h4>
                                <p>XII B-GREEN HOUSE CAPTAIN (GIRL)</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XIB-GREEN-HOUSE-VICE-CAPTAIN.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Upmanyu Mishra </h4>
                                <p>XI B-GREEN HOUSE VICE CAPTAIN</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/Arif-GREEN-HOUSE-VICE-CAPTAIN-GIRL.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Haniya Mohd </h4>
                                <p>Arif-GREEN HOUSE VICE CAPTAIN (GIRL)</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XIIA-PRESIDENT-LIT-ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Aastha Jaiswal </h4>
                                <p>XII A-PRESIDENT LIT. ASSOCIATION </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XIB-VICEPRESIDENT-LIT-ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>BIBi Zainab Salim </h4>
                                <p>XI B-VICE PRESIDENT LIT ASSOCIATION </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-B-PRESIDENT-HINDI-ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Shreya  </h4>
                                <p>XI B-VICE PRESIDENT LIT ASSOCIATION </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XI-A-VICE-PRESIDENT-HINDI-ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Sankalp Pandey </h4>
                                <p>XI A-VICE PRESIDENT HINDI ASSOCIATION  </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-B-PRESIDENT-IT-ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Rishika Srivastava </h4>
                                <p>XII B-PRESIDENT IT ASSOCIATION </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XIA-VICE-PRESIDENT-IT-ASSOCIATION..JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Vasundhara Bind </h4>
                                <p>XI A-VICE PRESIDENT IT ASSOCIATION</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-A-PRESIDENTART-ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Satyam Pandey </h4>
                                <p>XII A-PRESIDENT ART ASSOCIATION </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XI-A-VICE-PRESIDENT-ART-ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Insha Rizvi </h4>
                                <p>XI A-VICE PRESIDENT ART ASSOCIATION</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-A-PRESIDENT-SCIENCE-ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Khushboo Tiwari </h4>
                                <p>XII A-PRESIDENT SCIENCE ASSOCIATION</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XI-B-VICE-PRESIDENT-SCIENCE-ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Akshat Kesharvani </h4>
                                <p>XI B-VICE PRESIDENT SCIENCE ASSOCIATION </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-C-PRESIDENT-COMMERCE-ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Shatakshi Srivastava </h4>
                                <p>XII C-PRESIDENT COMMERCE ASSOCIATION </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XI-C-VICE-PRESIDENT-COMMERCE-ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Prabhjot Kaur </h4>
                                <p>XI C-VICE PRESIDENT COMMERCE ASSOCIATION</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-B-PRESIDENT-MUSIC-ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Divy Pratap Singh </h4>
                                <p>XII B-PRESIDENT MUSIC ASSOCIATION</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XI-B-VICE-PRESIDENT-ASSOCIATION.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Harshita Mishra </h4>
                                <p>XI B-VICE PRESIDENT ASSOCIATION</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XII-C-PRESIDENT-ENVIRONMENTAL-CLUB.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Ankita Kushwaha </h4>
                                <p>XII C-PRESIDENT ENVIRONMENTAL CLUB</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Officebearers/XI-B-VICE-PRESIDENT-ENVIRONMENTAL-CLUB.JPG" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Jay Jaiswal </h4>
                                <p>XI B-VICE PRESIDENT ENVIRONMENTAL CLUB </p>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
            <Footer />
        </>
    )
}
export default OfficeBearers